import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const GoToTopButton = () => {
  const handleGoToTop = () => {
    // Implement the logic to scroll to the top of the page here
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <OverlayTrigger
      placement="left"
      overlay={<Tooltip id="go-to-top-tooltip">Go to Top</Tooltip>}
    >
      <Button
        style={{ position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: "1000"}}
        onClick={handleGoToTop}
      >
        ↑
      </Button>
    </OverlayTrigger>
  );
};

export default GoToTopButton;
